function MaradonaSpecifierBadge({ specifier, iconOnly = false }) {
  if (!specifier && !iconOnly) return null;

  return (
    <span className="d-inline-flex align-items-center gap-1" style={{ flexShrink: 0 }}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8 4H16V7C16 9.2 14.2 11 12 11C9.8 11 8 9.2 8 7V4Z"
          fill="#FFD54A"
          stroke="#8B6914"
          strokeWidth="1.2"
          strokeLinejoin="round"
        />
        <path
          d="M8 5H5V6.6C5 8.1 6.2 9.3 7.7 9.3H8"
          stroke="#8B6914"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 5H19V6.6C19 8.1 17.8 9.3 16.3 9.3H16"
          stroke="#8B6914"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.2 11H13.8V14H10.2V11Z"
          fill="#FFC107"
          stroke="#8B6914"
          strokeWidth="1.1"
          strokeLinejoin="round"
        />
        <path
          d="M8.5 15H15.5V17H8.5V15Z"
          fill="#FFD54A"
          stroke="#8B6914"
          strokeWidth="1.1"
          strokeLinejoin="round"
        />
        <path
          d="M7 18H17V20H7V18Z"
          fill="#FFEEA8"
          stroke="#8B6914"
          strokeWidth="1.1"
          strokeLinejoin="round"
        />
      </svg>
      {iconOnly ? null : (
        <span className="fs-8 fw-semibold" style={{ color: '#AF021F', minWidth: '1.75rem', textAlign: 'center' }}>
          {specifier}
        </span>
      )}
    </span>
  );
}

export default MaradonaSpecifierBadge;
